import { __commonJSMin as e } from "../../../../../../../../../_virtual/_rolldown/runtime.js";
import { require_default as t } from "./default.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0/node_modules/@intercom/intercom-sanitizer/dist/html/config/inbox-composer.js
var n = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.INBOX_COMPOSER_CONFIG = void 0;
	var n = t();
	e.INBOX_COMPOSER_CONFIG = Object.assign({}, n.DEFAULT_CONFIG, { ALLOW_UNKNOWN_PROTOCOLS: !0 });
}));
//#endregion
export default n();
export { n as require_inbox_composer };
